"use strict";

exports.__esModule = true;
var _DeviceDetailsURLFilter = require("./DeviceDetailsURLFilter");
Object.keys(_DeviceDetailsURLFilter).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DeviceDetailsURLFilter[key]) return;
  exports[key] = _DeviceDetailsURLFilter[key];
});